var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"chan-pin-man-yi-du"},[_c('PageBlock',{attrs:{"title":"产品满意度"}},[_c('div',{staticClass:"content"},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"260px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }